import { setPresenceUsersIfChanged } from '@/hooks/collaboration-presence-utils';
import { readNodePresenceUsers, type CollaborationPresenceUser } from '@/lib/collaboration-presence';
import type { TiptapCollabProvider } from '@tiptap-pro/provider';
import { useEffect, useState } from 'react';

export function useCollaborationNodePresence(
    collabProvider: TiptapCollabProvider | null,
    nodeId: string | null,
): CollaborationPresenceUser[] {
    const [users, setUsers] = useState<CollaborationPresenceUser[]>(() =>
        collabProvider && nodeId ? readNodePresenceUsers(collabProvider, nodeId) : [],
    );

    useEffect(() => {
        if (!collabProvider || !nodeId) {
            return;
        }

        const update = () => setPresenceUsersIfChanged(setUsers, readNodePresenceUsers(collabProvider, nodeId));
        update();
        collabProvider.awareness?.on('update', update);

        return () => {
            collabProvider.awareness?.off('update', update);
        };
    }, [collabProvider, nodeId]);

    return collabProvider && nodeId ? users : [];
}
